import {API} from "@/components/_Shared/API/API"
import {PointOfContactProps} from "@/interfaces/point-of-contact_types.ts";
import {
    CREATE_POINT_OF_CONTACT, DELETE_POINT_OF_CONTACT, GET_POINT_OF_CONTACT_BY_UUID,
    GET_POINT_OF_CONTACTS,
    UPDATE_POINT_OF_CONTACT
} from "@/api/Endpoints/point-of-contact.ts";

export function createPointOfContact(data: PointOfContactProps) {
    return API.post<PointOfContactProps>(CREATE_POINT_OF_CONTACT, data)
}

export function getPointOfContact(filters? : string) {
    return API.get<PointOfContactProps>(GET_POINT_OF_CONTACTS, { params: { filters }})
}

export function updatePointOfContact(data: PointOfContactProps) {
    return API.put<PointOfContactProps>(UPDATE_POINT_OF_CONTACT.replace("{uuid}", data.uuid), data)
}

export function deletePointOfContact(uuid: string) {
    return API.delete<PointOfContactProps>(DELETE_POINT_OF_CONTACT.replace("{uuid}", uuid))
}

export function getPointOfContactById(uuid: string) {
    return API.get<PointOfContactProps>(GET_POINT_OF_CONTACT_BY_UUID.replace("{uuid}", uuid))
}